const Common = {
  data(){
    return {
      itemStatus:{
        "":{text:"等待中",type:"info"},
        WAITING:{text:"等待中",type:"info"},
        QUEUE:{text:"排队中",type:"warning"},
        RUNNING:{text:"采集中",type:""},
        COMPLETED:{text:"已完成",type:"success"},
        FAILED:{text:"失败",type:"danger"},
      },
      taskTypes:{
        "":{text:"未知",type:"info"},
        TIMING:{text:"定时任务",type:"info"},
        TEMPORARY:{text:"临时任务",type:"warning"},
      },
    }
  },
  created(){
    
  },
  methods:{
    copy(data){
      return JSON.parse(JSON.stringify(data));
    },
    format(fmt='yyyy-MM-dd HH:mm:ss',date) { //author: meizz 
      if(!date){
        date = new Date();
      }
      var o = {
          "M+": date.getMonth() + 1, //月份 
          "d+": date.getDate(), //日 
          "h+": date.getHours(), //小时 
          "H+": this.getMakeZero(date.getHours()), //小时 
          "m+": date.getMinutes(), //分 
          "s+": date.getSeconds(), //秒 
          "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
          "S": date.getMilliseconds() //毫秒 
      };
      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o){
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
      return fmt;
    },
    getMakeZero(s){
      return s < 10 ? '0' + s : s;
    },
    object2urlparams(data){
      return Object.keys(data).map(function (key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
      }).join("&");
    },
    fixCommunityRresourceList(list) {
      console.log(list, Array.isArray(list));
      if (Array.isArray(list)) {
        list.forEach(data => {
          if (data.authorHeadImg){
            this.fixRresource(data.authorHeadImg);
          }
          
          if (data.resources){
            data._resources = [];
            data.resources.forEach(resource => {
              this.fixRresource(resource);
              data._resources.push(resource.url);
            });
          }
          
          if (data.topResources){
            data.topResources.forEach(resource => {
              console.log(resource);
              this.fixRresource(resource);
            });
          }
        });
        return list;
      } else return [];
    },
    fixRresourceList(list){
      if (Array.isArray(list)) {
        list.forEach(resource => {
          this.fixRresource(resource);
        })
      }
      return list;
    },
    fixRresource(resource) {
      resource.url && (resource.url = resource.url.replace("OSSAccessKeyId", "OSS_AccessKeyId"));
      resource.thumbUrl && (resource.thumbUrl = resource.thumbUrl.replace("OSSAccessKeyId", "OSS_AccessKeyId"));
      resource.screenshotUrl && (resource.screenshotUrl = resource.screenshotUrl.replace("OSSAccessKeyId", "OSS_AccessKeyId"));
      return resource;
    }
  }
};

export default Common;